function updateShippingDate() {
  var el = document.querySelector('.shipping-date-value');
  if (!el) return;
  var today = new Date();
  var tomorrow = new Date(today);
  tomorrow.setDate(today.getDate() + 1);
  var opts = { weekday: 'long', day: 'numeric', month: 'long' };
  el.textContent = tomorrow.toLocaleDateString('en-US', opts);
}

document.addEventListener('DOMContentLoaded', function() {
  updateShippingDate();
  // re-run when the color/variant changes
  document.querySelectorAll('input[name="Color"], select[name="Color"]')
    .forEach(i => i.addEventListener('change', updateShippingDate));
  document.addEventListener('variant:change', updateShippingDate);
});
